module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr16-7386b82f1463cd085e868a6e0f61da76.jpg";